/*
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import SimpleBackgroundCard from "components/Cards/BackgroundCards/SimpleBackgroundCard";
import jonathan from "assets/images/jonathan.jpg";

function Information() {
    return (
        <MKBox component="section" py={6} mt={6}>
            <Container>
                <Grid container justifyContent="flex-start">
                    <Grid item sx={{ width: 256, height: 256 }}>
                        <SimpleBackgroundCard image={jonathan} title="" description="" />
                    </Grid>
                    <Grid container spacing={3} item xs={12} lg={8} mx="auto">
                        <MKTypography
                            component="h6"
                            variant="button"
                            opacity={0.7}
                            textTransform="uppercase"
                            fontWeight="bold"
                        ></MKTypography>
                        <MKTypography variant="h3" mb={3}>
                            Erialos | The Silver Fox | Jonathan
                        </MKTypography>
                        <MKTypography variant="body2">
                            Hello, my name is Jonathan. You probably know me by Erialos or The
                            Silver Fox Validator if you&apos;ve found yourself here though!
                            <br /> <br />
                            I have been in the Crypto space since around 2019. I first started to
                            mine a POW chain called Cortex. Later I found another POW chain called
                            Vidulum. Towards the end of the year, Vidulum was switching to a dPOS
                            chain software called Cosmos SDK/Tendermint. I followed them in this
                            journey, just missing the chance to be apart of their genesis. Since
                            then we&apos;ve expanded into many more blockchains!
                            <br /> <br />I am a United State Marine Corps Veteran. While I did
                            Infantry in the Corps, I transitioned into IT/Computers afterwards. My
                            last IT Job, I was the Systems and Network Administrator in a medical
                            office. I eventually moved on and went to use my GIBill to attend my
                            state University. I attempted to get a BS in Math and Physics but my
                            mental health got the better of me and I dropped out with mostly
                            generals left. I hope to one day return and complete the pure math route
                            and earn a BS degree in Math.
                            <br /> <br />
                            Since dropping out, my life has changed quite a bit. I have always
                            enjoyed using my IT skills as a hobby and I have found working in crypto
                            fulfills that need. I really enjoy learning new things and figuring out
                            how things work.
                            <br /> <br />I believe in honesty being the best policy. I will always
                            try to be upfront and direct with everyone.
                        </MKTypography>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default Information;
